import { LinkToCompetition } from 'app/components/links/LinkToCompetition';
import React from 'react';
import { List, Typography } from '@fupa/fupa-uikit';
const CrawlerCompetitionLink = _ref => {
  let {
    competitionCategory,
    competitionList,
    className
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, competitionList.map(competition => /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(LinkToCompetition, {
    subpage: '',
    enablehover: true.toString(),
    competitionType: competitionCategory,
    key: competition.slug,
    competition: {
      ...competition,
      active: true
    }
  }, /*#__PURE__*/React.createElement(List, null, /*#__PURE__*/React.createElement(Typography, {
    variant: 'subheading'
  }, competition.name))))));
};
export default CrawlerCompetitionLink;